import React from "react";

const Close = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.95898 5.4209L7.31445 5.77539L13.0479 0.000976562L14.584 1.53711L8.81055 7.27148L9.16504 7.62695L14.585 13.0469L13.0479 14.584L7.31445 8.81055L6.95898 9.16504L1.53809 14.585L0 13.0469L5.4209 7.62695L5.77539 7.27148L0.000976562 1.53711L1.53809 0L6.95898 5.4209Z"
      fill={color}
    />
  </svg>
);

Close.defaultProps = {
  width: 28,
  height: 28,
  color: "black"
};

export default Close;
